import { Routes } from '@angular/router';
import { AuthGuard } from '@zmodules/auth/auth.guard';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () =>
            import('./modules/home/home.module').then((m) => m.HomeModule)
    },
    {
        path: 'auth',
        loadChildren: () =>
            import('./modules/auth/auth.module').then((m) => m.AuthModule)
    },
    {
        path: 'dashboard',
        loadChildren: () =>
            import('./modules/dashboard/dashboard.module').then(
                (m) => m.DashboardModule
            ),
        canActivate: [AuthGuard]
    },
    {
        path: 'invoice',
        loadChildren: () =>
            import('./modules/invoice/invoice.module').then(
                (m) => m.InvoiceModule
            ),
        canActivate: [AuthGuard]
    },
    {
        path: 'enterprise',
        loadChildren: () =>
            import('./modules/enterprise/enterprise.module').then(
                (m) => m.EnterpriseModule
            ),
        canActivate: [AuthGuard]
    },
    {
        path: 'liability',
        loadChildren: () =>
            import('./modules/liability/liability.module').then(
                (m) => m.LiabilityModule
            ),
        canActivate: [AuthGuard]
    },
    {
        path: 'error',
        loadChildren: () =>
            import('./modules/error-handler/error-handler.module').then(
                (m) => m.ErrorHandlerModule
            )
    }
];
